import { FormState } from '../../models';
import { basicInfo } from './basic-info';
import { dialogActions } from './dialog-actions';
import { configureAlarms } from './alarms';
import { dataDelivery } from './data-delivery';
import { flexInfo } from './flex-info';
import { FlexLocationCardState } from './models';

/**
 * FLEX form configuration
 */
export const flexFormState = (state: FlexLocationCardState): FormState => {
    const { locationCardData } = state;
    const { editMode } = locationCardData;

    return {
        config: {
            info: {
                id: 'flex-location-config',
                title: 'FLEX Location Configuration',
            },
            sections: editMode ? [
                basicInfo(state),
                flexInfo(state),
                configureAlarms(state),
                dataDelivery(state),
                dialogActions(state),
            ] : [
                basicInfo(state),
                dialogActions(state)
            ],
        },
        pristine: true,
        valid: false,
        submitted: false,
    };
}
